import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import Component from 'flarum/common/Component';
import Icon from 'flarum/common/components/Icon';
import classList from 'flarum/common/utils/classList';
const t = key => app.translator.trans(`tarotportal-theme.forum.auth.${key}`, {}, true);

/**
 * Show / hide a password: core's own <input> (its name, value binding, autocomplete, disabled)
 * with an eye button inside it on the right. The icon shows the current state (hidden: crossed-out
 * eye, shown: open eye); the label says what a press does ("Показать пароль" / "Скрыть пароль"). Each field keeps its own state; the button never
 * submits, never touches the value and keeps the cursor where it was.
 * The server-rendered password pages do the same with a small script (views/layouts/basic).
 */
export class PasswordVisibility extends Component {
  visible = false;
  view() {
    const input = this.attrs.input;
    const label = t(this.visible ? 'hide_password' : 'show_password');
    input.attrs = {
      ...input.attrs,
      type: this.visible ? 'text' : 'password',
      className: classList(input.attrs.className, 'TpPassword-input')
    };
    return m("div", {
      className: classList('TpPassword', this.visible && 'TpPassword--visible')
    }, input, m("button", {
      type: "button",
      className: "TpPassword-toggle",
      "aria-label": label,
      title: label,
      "aria-pressed": this.visible ? 'true' : 'false',
      disabled: input.attrs.disabled,
      onclick: () => this.toggle()
    }, m(Icon, {
      name: this.visible ? 'far fa-eye' : 'far fa-eye-slash'
    })));
  }
  toggle() {
    const field = this.element.querySelector('input');
    const start = field.selectionStart;
    const end = field.selectionEnd;
    this.visible = !this.visible;
    m.redraw.sync();
    const restore = () => {
      field.focus();
      if (start !== null && end !== null) field.setSelectionRange(start, end);
    };
    restore();
    // in case the tap's own focus handling runs after this: put the cursor back once it is over
    requestAnimationFrame(() => {
      if (document.activeElement !== field) restore();
    });
  }
}

/** Wraps every password <input> found in the given form items (one level of nesting per item). */
function withPasswordVisibility(items) {
  const wrap = vnode => {
    if (!vnode || typeof vnode !== 'object' || !Array.isArray(vnode.children)) return false;
    let changed = false;
    vnode.children = vnode.children.map(child => {
      if (child?.tag === 'input' && child.attrs?.type === 'password') {
        changed = true;
        return m(PasswordVisibility, {
          input: child
        });
      }
      if (wrap(child)) changed = true;
      return child;
    });
    return changed;
  };
  for (const key of Object.keys(items.toObject())) wrap(items.get(key));
}
export default function addPasswordVisibility() {
  for (const modal of ['LogInModal', 'SignUpModal', 'ChangeEmailModal']) {
    extend(`flarum/forum/components/${modal}`, 'fields', function (items) {
      withPasswordVisibility(items);
    });
  }
}